import { ll } from "./ll";

export const errorCode: { [key: string]: number } = {};

export function getErrorCodeName(code) {
    var name = null;
    $.each(errorCode, function (key, value) {
        if (value == code) {
            name = key;
        }
    });

    return name;
}

export function getErrorMessageHeader(args) {
    if (args.errorCode >= 1) {
        var message = ll(`ErrorCodeHeader${args.errorCode}`, true, false);
        if (message) {
            return message;
        }
    }

    return ll(args.defaultMessage || "ErrorCodeHeader0");
}

export function getErrorMessage(args) {
    if (args.errorCode >= 1) {
        var message = ll(`ErrorCode${args.errorCode}`, true, false);
        if (message) {
            return message;
        }
    }

    return ll(args.defaultMessage || "ErrorCode0");
}
